import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {
  Ech0134GrundbuchmeldungSearchRequest,
  Ech0134meldungsempfaengerService,
  MeldungsEmpfaengerListEntry,
  MeldungsEmpfaengerSearchRequest
} from '../../core/grundbuchmeldung-api';
import { Observable } from 'rxjs';
import { Ech0134ModuleStateData } from '../ech0134-module-state-data';
import { ListLoaderPaginationBuilder } from '../../shared/components/list-loader/list-loader-pagination';
import { PaginationLookupResult } from '../../shared/components/list-loader/pagination-lookup-result';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { LoadingState } from '../../shared/components/list-loader/loading-state';
import { first, map } from 'rxjs/operators';
import MeldungsEmpfaengerSortEnum = MeldungsEmpfaengerSearchRequest.MeldungsEmpfaengerSortEnum;
import SortDirectionEnum = Ech0134GrundbuchmeldungSearchRequest.SortDirectionEnum;

@Injectable()
export class MeldungsempfaengerListResolver {
  constructor(
    private moduleStateData: Ech0134ModuleStateData,
    private backend: Ech0134meldungsempfaengerService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<ListLoader<MeldungsEmpfaengerListEntry>>
    | Promise<ListLoader<MeldungsEmpfaengerListEntry>>
    | ListLoader<MeldungsEmpfaengerListEntry> {
    const searchRequest = <MeldungsEmpfaengerSearchRequest>(JSON.parse(route.queryParams.request) || {});
    this.moduleStateData.lastEmpfaengerSearchRequest = searchRequest;
    const listLoader = ListLoaderPaginationBuilder.builder<MeldungsEmpfaengerListEntry>()
      .setNoSortModel(true)
      .setCurrentPage(1)
      .setPageSize(15)
      .setLookupItemFunc((offset, limit, sortColumn) => {
        searchRequest.offset = offset;
        searchRequest.limit = limit;
        searchRequest.meldungsEmpfaengerSort = sortColumn ? sortColumn.sortEnumBackend : MeldungsEmpfaengerSortEnum.BEZEICHNUNG;
        searchRequest.sortDirection = sortColumn ? sortColumn.sortDirectionBackend : SortDirectionEnum.ASC;
        return this.backend.searchEmpfaenger(searchRequest).pipe(
          map((response) => {
            return <PaginationLookupResult<MeldungsEmpfaengerListEntry>>{
              result: response.results,
              totalItems: response.totalItems
            };
          })
        );
      })
      .build();
    return new Promise((resolve1) => {
      listLoader.state$.pipe(first((state1) => state1 === LoadingState.ALL_DATA_LOADED)).subscribe(() => {
        resolve1(listLoader);
      });
    });
  }
}
